import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { accountsToFilterOut } from 'src/app/authentication/state/authentication.selector';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import {
   PhoneNumberDetailDeleteEvent,
   PhoneNumberDetailReleaseEvent,
} from 'src/app/pages/phone-number-details/models/phone-number-detail-form-submit-event';
import * as PhoneNumberDetailActions from 'src/app/pages/phone-number-details/state/phone-number-detail.actions';
import { Privileges } from 'src/app/privileges/privileges';
import { PhoneNumbersFilterOption } from '../../models/phone-number-filter-option';
import { PhoneNumberRegister } from '../../phone-number-register';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-system-phone-number-register',
    templateUrl: './system-phone-number-register.component.html',
    standalone: false
})
export class SystemPhoneNumberRegisterComponent extends PhoneNumberRegister {
   constructor(public store: Store) {
      super(store);
      this.store
         .select(accountsToFilterOut(Privileges.ManagePhoneNumberSettings_View))
         .pipe(
            map((accountIds: number[]) => {
               if (accountIds.length > 0) {
                  const filters: PhoneNumbersFilterOption[] = [
                     {
                        field: 'AccountId',
                        operation: FilterOperations.NotIn,
                        type: 'numeric',
                        value: accountIds,
                     },
                  ];
                  return filters;
               }
               return [];
            })
         )
         .subscribe((filters: PhoneNumbersFilterOption[]) => {
            this.filters = filters;
            this.columns = [
               'accountName',
               'phoneNumber',
               'providerId',
               'isActive',
               'isPorted',
               'datePorted',
               'systemPhoneNumberActionsMenu',
            ];
         });
   }
   onNumberReleased(event: PhoneNumberDetailReleaseEvent): void {
      this.store.dispatch(PhoneNumberDetailActions.releasePhoneNumberDetail(event));
   }

   onNumberDeleted(event: PhoneNumberDetailDeleteEvent): void {
      this.store.dispatch(PhoneNumberDetailActions.deletePhoneNumberDetailFromNDT(event));
   }
}
